import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  open: false,
  startIndex: 0,
  items: [],
};

const selectSliderOpen = (state) => state.slider.open;
const selectSliderItems = (state) => state.slider.items;
const selectSliderStartIndex = (state) => state.slider.startIndex;

export const selectorSliderOpen = createSelector([selectSliderOpen], (o) =>
  Boolean(o)
);
export const selectorSliderItems = createSelector([selectSliderItems], (o) =>
  o.map((o) => o)
);
export const selectorSliderStartIndex = createSelector(
  [selectSliderStartIndex],
  (o) => Number(o)
);

const sliderSlice = createSlice({
  name: "slider",
  initialState,
  reducers: {
    setSliderOptions: (state, { payload }) => {
      const { open, startIndex, items } = payload;
      state.open = open;
      state.items = items;
      state.startIndex = startIndex || 0;
    },
    resetSlider: () => initialState,
  },
  extraReducers: (b) => {},
});

export const selectSlider = ({ utils }) => utils.slider;
export const { setSliderOptions, resetSlider } = sliderSlice.actions;
export default sliderSlice.reducer;
